import { Waiter } from "common/promises";
import { paths } from "from-start/scene/resources";
import { html, LitElement } from "lit-element";
import { nothing } from "lit-html";
import { classMap } from "lit-html/directives/class-map";
import log from "loglevel";
export class Video360Root extends LitElement {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.preloadAframe = false;
        this.videoLoaded = false;
        this.announce = false;
        this.loadingFadeOut = false;
        this.fadeIn = true;
        this.progressElem = false;
        this.showSelfieIcon = false;
        this.flip = false;
        this.overlay = {
            showBottomForVideo: false,
        };
        this.hasRendered = new Waiter();
        this.hasAnnounceClicked = new Waiter();
        this.hasSelfieIconClicked = new Waiter();
    }
    static get properties() {
        return {
            loading: { type: Boolean },
            preloadAframe: { type: Boolean },
            videoLoaded: { type: Boolean },
            announce: { type: Boolean },
            loadingFadeOut: { type: Boolean },
            fadeIn: { type: Boolean },
            progressElem: { type: Boolean },
            showSelfieIcon: { type: Boolean },
            overlay: { type: Object },
        };
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        this.hasRendered.trigger();
    }
    loadingElement() {
        return this.querySelector("jh-360-video-loading");
    }
    async awaitAnnounceClick() {
        await this.hasAnnounceClicked.wait();
    }
    render() {
        const announceClass = {
            dn: !this.announce,
        };
        const loadingClass = {
            dn: !this.loading,
        };
        const showAscene = !this.loading || this.preloadAframe;
        const asceneClass = {
            dn: !showAscene,
        };
        const progressClass = {
            dn: !this.progressElem,
        };
        let blackOut = false;
        if (this.loading && this.loadingFadeOut) {
            blackOut = true;
        }
        else if (!this.loading && this.fadeIn) {
            blackOut = true;
        }
        const aSceneHTML = html `
      <div class=${classMap(asceneClass)}>
        <div class="flip-card">
          <div class="flip-card-inner ${classMap({ flip: this.flip })}">
            ${showAscene
            ? html `<a-scene
                  class="pointer-allow absolute top-0 left-0 flip-card-front"
                  embedded
                  vr-mode-ui="enabled: false"
                  device-orientation-permission-ui="enabled: false"
                >
                  ${this.videoLoaded
                ? html `<a-videosphere
                        rotation="0 -90 0"
                        src="#video-360"
                      ></a-videosphere>`
                : nothing}
                  <a-camera user-height="0" fov="120"> </a-camera>
                  <jh-render-debug name="ascene-root"></jh-render-debug>
                </a-scene>`
            : nothing}
            <!--video id="selfievideo" playsinline webkit-playsinline class="flip-card-back"-->
          </div>
        </div>
        <jh-camera-flash></jh-camera-flash>
        <jh-360-video-overlay
          ?showBottomForVideo=${this.overlay.showBottomForVideo}
        ></jh-360-video-overlay>
        <jh-360-video-progress
          class="${classMap(progressClass)}"
        ></jh-360-video-progress>
        <jh-360-video-announce
          @announceClick=${this.handleAnnounceClick}
          class="${classMap(announceClass)}"
        ></jh-360-video-announce>
        <jh-360-video-subtitle text=""></jh-360-video-subtitle>
        ${this.renderSelfieIcon()}
      </div>
      <jh-360-video-loading
        class=${classMap(loadingClass)}
      ></jh-360-video-loading>
      <jh-360-video-loading-paused></jh-360-video-loading-paused>
      <jh-black-out ?on=${blackOut}></jh-black-out>
    `;
        return aSceneHTML;
    }
    handleAnnounceClick() {
        this.hasAnnounceClicked.trigger();
    }
    renderSelfieIcon() {
        if (this.showSelfieIcon) {
            return html `<img
        class="absolute pointer-allow"
        @click=${this.handleSelfieIconClick}
        src=${paths.video360SelfieIcon}
      />`;
        }
        else {
            return nothing;
        }
    }
    handleSelfieIconClick() {
        log.debug("selfieicon clicked");
        this.flip = true;
        this.querySelector("#selfievideo").play();
        this.hasSelfieIconClicked.trigger();
        this.removeAttribute("showSelfieIcon");
    }
}
customElements.define("jh-360-video-root", Video360Root);
//# sourceMappingURL=video360root.js.map